package com.nonopn.icons

import androidx.compose.material.icons.Icons
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.EvenOdd
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp

public val Icons.Rounded.ScanQr: ImageVector
    get() {
        if (_scanQr != null) {
            return _scanQr!!
        }
        _scanQr =
            Builder(
                name = "ScanQr",
                defaultWidth = 24.0.dp,
                defaultHeight = 24.0.dp,
                viewportWidth = 24.0f,
                viewportHeight = 24.0f,
            )
                .apply {
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd,
                    ) {
                        moveTo(2.25f, 3.0f)
                        curveTo(2.25f, 2.586f, 2.586f, 2.25f, 3.0f, 2.25f)
                        horizontalLineTo(8.4f)
                        curveTo(8.814f, 2.25f, 9.15f, 2.586f, 9.15f, 3.0f)
                        curveTo(9.15f, 3.414f, 8.814f, 3.75f, 8.4f, 3.75f)
                        horizontalLineTo(3.75f)
                        verticalLineTo(8.4f)
                        curveTo(3.75f, 8.814f, 3.414f, 9.15f, 3.0f, 9.15f)
                        curveTo(2.586f, 9.15f, 2.25f, 8.814f, 2.25f, 8.4f)
                        verticalLineTo(3.0f)
                        close()
                        moveTo(14.85f, 3.0f)
                        curveTo(14.85f, 2.586f, 15.186f, 2.25f, 15.6f, 2.25f)
                        horizontalLineTo(21.0f)
                        curveTo(21.414f, 2.25f, 21.75f, 2.586f, 21.75f, 3.0f)
                        verticalLineTo(8.4f)
                        curveTo(21.75f, 8.814f, 21.414f, 9.15f, 21.0f, 9.15f)
                        curveTo(20.586f, 9.15f, 20.25f, 8.814f, 20.25f, 8.4f)
                        verticalLineTo(3.75f)
                        horizontalLineTo(15.6f)
                        curveTo(15.186f, 3.75f, 14.85f, 3.414f, 14.85f, 3.0f)
                        close()
                        moveTo(3.0f, 14.85f)
                        curveTo(3.414f, 14.85f, 3.75f, 15.186f, 3.75f, 15.6f)
                        verticalLineTo(20.25f)
                        horizontalLineTo(8.4f)
                        curveTo(8.814f, 20.25f, 9.15f, 20.586f, 9.15f, 21.0f)
                        curveTo(9.15f, 21.414f, 8.814f, 21.75f, 8.4f, 21.75f)
                        horizontalLineTo(3.0f)
                        curveTo(2.586f, 21.75f, 2.25f, 21.414f, 2.25f, 21.0f)
                        verticalLineTo(15.6f)
                        curveTo(2.25f, 15.186f, 2.586f, 14.85f, 3.0f, 14.85f)
                        close()
                        moveTo(21.0f, 14.85f)
                        curveTo(21.414f, 14.85f, 21.75f, 15.186f, 21.75f, 15.6f)
                        verticalLineTo(17.0f)
                        curveTo(21.75f, 17.414f, 21.414f, 17.75f, 21.0f, 17.75f)
                        curveTo(20.586f, 17.75f, 20.25f, 17.414f, 20.25f, 17.0f)
                        verticalLineTo(15.6f)
                        curveTo(20.25f, 15.186f, 20.586f, 14.85f, 21.0f, 14.85f)
                        close()
                        moveTo(21.0f, 19.25f)
                        curveTo(21.414f, 19.25f, 21.75f, 19.586f, 21.75f, 20.0f)
                        verticalLineTo(21.0f)
                        curveTo(21.75f, 21.414f, 21.414f, 21.75f, 21.0f, 21.75f)
                        horizontalLineTo(15.6f)
                        curveTo(15.186f, 21.75f, 14.85f, 21.414f, 14.85f, 21.0f)
                        curveTo(14.85f, 20.586f, 15.186f, 20.25f, 15.6f, 20.25f)
                        horizontalLineTo(20.25f)
                        verticalLineTo(20.0f)
                        curveTo(20.25f, 19.586f, 20.586f, 19.25f, 21.0f, 19.25f)
                        close()
                    }
                    path(
                        fill = SolidColor(Color(0xFF000000)),
                        stroke = null,
                        strokeLineWidth = 0.0f,
                        strokeLineCap = Butt,
                        strokeLineJoin = Miter,
                        strokeLineMiter = 4.0f,
                        pathFillType = EvenOdd,
                    ) {
                        moveTo(1.25f, 12.0f)
                        curveTo(1.25f, 11.586f, 1.586f, 11.25f, 2.0f, 11.25f)
                        horizontalLineTo(22.0f)
                        curveTo(22.414f, 11.25f, 22.75f, 11.586f, 22.75f, 12.0f)
                        curveTo(22.75f, 12.414f, 22.414f, 12.75f, 22.0f, 12.75f)
                        horizontalLineTo(2.0f)
                        curveTo(1.586f, 12.75f, 1.25f, 12.414f, 1.25f, 12.0f)
                        close()
                    }
                }
                .build()
        return _scanQr!!
    }

private var _scanQr: ImageVector? = null
